import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { CookieService } from "ngx-cookie-service";
import { ApiMethodService } from "../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { optionResponse } from "../models/form.model";

@Injectable({
    providedIn: 'root',
})
export class ApiTableService {
    private baseUrl = `${environment.apiPrivateUrl}`;
    token = '';
    constructor(
        private http: HttpClient,
        private cookieService: CookieService,
        private apiMethodService: ApiMethodService
    ) {
        this.token = this.cookieService.get('token');
    }

    getParkingSiteList(): Observable<optionResponse> {
        const token = this.cookieService.get('token');
        const userId = this.cookieService.get('user_id');
        return this.apiMethodService.request<optionResponse>(
            '/backoffice/GetParkingSiteByUser',
            'GET',
            this.baseUrl,
            {
                isConsoleLog: true,
                labelLog: 'GetParkingSiteByUser',
                token: token,
                headerOnly: false,
                params: {
                    userId: userId
                }
            },
        );
    }


}